<template>
  <tr>
    <td class="text-no-wrap">
      {{ staff.name }}
    </td>
    <td style="width: 1px">
      {{ staff.total_hours_spent }} h
    </td>
    <td style="width: 1px">
      {{ staff.total_assigned_tasks_count }}
    </td>
    <td style="width: 1px">
      {{ staff.total_finished_tasks_count }}
    </td>
  </tr>
</template>

<script>
export default {
  name: 'StaffStatsTableRow',
  props: {
    staff: {
      type: Object,
      required: true
    }
  }
}
</script>
